<template>
  <div id="AssemblyEdit_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $route.query.id != undefined ? '編輯':'建立新' }}會議
          </div>
        </div>
        <div class="required">
          為必填
        </div>
      </div>
      <el-tabs
        v-model="activeName"
        :before-leave="beforeLeave"
      >
        <el-tab-pane
          label="Step 1. 填寫會議基本資料"
          name="1"
        >
          <el-form
            ref="form"
            :model="data"
            :rules="rules"
            label-position="left"
            label-width="130px"
            hide-required-asterisk
          >
            <el-form-item
              label="會議名稱"
              prop="title"
            >
              <el-input
                v-model="data.title"
                placeholder="請輸入會議名稱"
                maxlength="100"
                show-word-limit
              />
              <span class="ex">範例：第一屆 第一次 區分所有權人定期會議</span>
            </el-form-item>
            <el-form-item
              label="會議類型"
              required
            >
              <el-radio
                v-model="data.category"
                label="0"
                @change="categoryChange"
              >
                定期
              </el-radio>
              <el-radio
                v-model="data.category"
                label="1"
                @change="categoryChange"
              >
                臨時
              </el-radio>
            </el-form-item>
            <el-form-item
              label="會議日期"
              prop="date"
            >
              <el-date-picker
                ref="date"
                v-model="data.date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                :picker-options="pickerOptions"
                placeholder="請選擇會議日期"
                @change="$refs.time1.focus()"
              />
              <span>{{ error.date }}</span>
            </el-form-item>
            <el-form-item
              label="開始時間"
              required
            >
              <el-form-item
                prop="startTime"
                class="time"
              >
                <el-time-select
                  ref="time1"
                  v-model="data.startTime"
                  :picker-options="{ start: '06:00', end: '22:00', step: '00:30', maxTime: data.endTime }"
                  placeholder="會議開始時間"
                />
              </el-form-item>
            </el-form-item>
            <el-form-item label="結束時間">
              <el-form-item class="time">
                <el-time-select
                  v-model="data.endTime"
                  :picker-options="{ start: '06:00', end: '22:00', step: '00:30', minTime: data.startTime }"
                  placeholder="會議結束時間"
                />
              </el-form-item>
            </el-form-item>
            <el-form-item
              label="會議地點"
              prop="place"
            >
              <el-input
                v-model="data.place"
                placeholder="請輸入會議地點"
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
            <el-form-item
              label="會議地址"
              prop="placeAddress"
            >
              <el-input
                v-model="data.placeAddress"
                placeholder="請輸入會議地址"
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
            <el-form-item label="發文字號">
              <el-input
                v-model="data.issueTextNumber"
                placeholder="請輸入發文字號"
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
            <el-form-item
              label="會議召集人"
              required
            >
              <el-radio-group
                v-model="data.hostIdentity"
                @change="$nextTick(()=>$refs.chairman.focus())"
              >
                <el-radio
                  v-for="(item,index) in hostOptions"
                  :key="index"
                  :label="item.label"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
              <el-form-item prop="host">
                <el-input
                  ref="chairman"
                  v-model="data.host"
                  placeholder="請輸入會議召集人名稱"
                  maxlength="100"
                  show-word-limit
                  class="short"
                />
              </el-form-item>
            </el-form-item>
            <el-form-item label="聯絡人">
              <el-radio-group
                v-model="data.contactPersonIdentity"
                @change="$nextTick(()=>$refs.contactPerson.focus())"
              >
                <el-radio
                  v-for="(item,index) in contactPersonOptions"
                  :key="index"
                  :label="item.label"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
              <el-input
                ref="contactPerson"
                v-model="data.contactPerson"
                placeholder="請輸入聯絡人"
                maxlength="100"
                show-word-limit
              />
            </el-form-item>
            <el-form-item
              label="會議程序"
              prop="description"
            >
              <template>
                <textarea
                  v-model="data.description"
                  name="editor"
                />
              </template>
            </el-form-item>
            <el-form-item label="備註">
              <el-input
                v-model="data.note"
                type="textarea"
                placeholder="請輸入備註"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </el-form>
          <el-button
            round
            @click="cancel"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            round
            @click="nextStep"
          >
            下一步
          </el-button>
        </el-tab-pane>
        <el-tab-pane
          label="Step 2. 填寫議案資料"
          name="2"
        >
          <div class="content">
            <div class="left">
              <span>報到統計規則</span>
            </div>
            <div class="right">
              <el-checkbox
                v-model="data.useTablet"
                @change="handleThresholdCheckboxChange"
              >
                出席人數
              </el-checkbox>
              <el-checkbox
                v-model="data.useArea"
                @change="handleThresholdCheckboxChange"
              >
                區分所有權佔比
              </el-checkbox>
              <div class="threshold">
                <el-input-number
                  v-if="data.useTablet || data.useArea"
                  v-model="data.num"
                  class="inputnum"
                  :class="error.threshold ? 'error' : ''"
                  :precision="2"
                  :step="1"
                  :min="1"
                  :max="100"
                  @change="checkThreshold"
                />
                <div
                  v-if="error.threshold"
                  class="errorNum"
                >
                  {{ ErrorMsg.THRESHOLD_EMPTY }}
                </div>
              </div>
              <div
                v-if="data.useTablet || data.useArea"
                class="num"
              >
                ％
              </div>
            </div>
          </div>
          <TopicEdit
            ref="topicEdit"
            :main-threshold="data.num"
          />
          <div class="bottomControl">
            <el-button
              round
              @click="backStep"
            >
              上一步
            </el-button>
            <el-button
              type="primary"
              round
              @click="nextStep"
            >
              下一步
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="Step 3. 編輯區權人名冊資料"
          name="3"
        >
          <div v-if="reUpload">
            <EditRegisterList ref="editRegisterList" />
          </div>
          <div
            v-else
            class="content"
          >
            <File
              type="file"
              name="file"
              :accept-file-type="fileAcceptFileType"
              :is-accept-file-size-limited="false"
              :filearray="files"
              :quantity="1"
              :class="error.file ? 'redFile' : ''"
              @on-fileArray-change="filesChange"
            />
            <div
              v-if="error.file"
              class="fileError"
            >
              {{ ErrorMsg.FILE_EMPTY }}
            </div>
            <div class="file-content">
              <span>請點此</span>
              <span
                class="green"
                @click="printSample()"
              >下載空白範本</span>
              <span>輸入資料，儲存檔案後請點擊【新增檔案】按鈕匯入</span>
            </div>
          </div>
          <div class="bottomControl">
            <el-button
              round
              @click="backStep"
            >
              上一步
            </el-button>
            <el-button
              type="primary"
              round
              @click="submit"
            >
              儲存會議
            </el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { processCKEditorData } from '@/js/utils/ckeditor.js'
import TopicEdit from './components/TopicEdit'
import File from '@/components/File'
import EditRegisterList from './components/EditRegisterList'
export default {
  components: {
    TopicEdit,
    File,
    EditRegisterList
  },
  data () {
    const required = (rule, value, callback) => {
      value = value.trim()
      // eslint-disable-next-line eqeqeq
      if (value == '') {
        callback(new Error('內容不可為空白'))
        value = ''
      } else { callback() }
    }
    return {
      ErrorMsg: {
        THRESHOLD_EMPTY: '請輸入報到標準',
        FILE_EMPTY: '請新增檔案'
      },
      error: {
        date: '',
        threshold: false,
        file: false
      },
      activeName: '1',
      communityId: '',
      communityName: '',
      data: {
        title: '',
        date: '', // 會議日期
        issueTextNumber: '', // 發文字號
        category: '0', // 會議類型
        startTime: '', // 會議開始時間
        endTime: '', // 會議結束時間
        place: '', // 會議地點
        placeAddress: '', // 會議地址
        host: '', // 主席
        hostIdentity: 'Chairperson', // 主席身份
        contactPerson: '', // 聯絡人
        contactPersonIdentity: '', // 聯絡人身份
        description: '', // 會議程序
        num: 50,
        note: '', // 備註
        useTablet: true, // 出席人數 checkbox
        useArea: false, // 區分所有權佔比 checkbox
        unitOwnerListExcel: [] // step3
      },
      rules: {
        title: [{ required: true, message: '請輸入會議名稱', trigger: 'change' }, { validator: required, trigger: 'change' }],
        date: [{ required: true, message: '請選擇會議日期', trigger: 'change' }, { validator: required, trigger: 'change' }],
        startTime: [{ required: true, message: '請選擇會議開始時間', trigger: 'change' }, { validator: required, trigger: 'change' }],
        place: [{ required: true, message: '請輸入會議地點', trigger: 'change' }, { validator: required, trigger: 'change' }],
        host: [{ required: true, message: '請輸入會議召集人名稱', trigger: 'change' }, { validator: required, trigger: 'change' }]
      },
      hostOptions: [ // 主席身份選項
        {
          name: '主任委員',
          label: 'Chairperson'
        }, {
          name: '起造人',
          label: 'Builder'
        }, {
          name: '其他',
          label: 'Others'
        }
      ],
      contactPersonOptions: [ // 聯絡人身份選項
        {
          name: '社區經理',
          label: 'Manager'
        }, {
          name: '管理員',
          label: 'Staff'
        }, {
          name: '委員',
          label: 'CommitteeMember'
        }, {
          name: '其他',
          label: 'Others'
        }
      ],
      pickerOptions: {
        disabledDate: (time) => { // 設置會議時間選擇器 時間範圍限制
          const day = -1
          return time.getTime() < (new Date().getTime() + day * 24 * 60 * 60 * 1000)
        }
        // * 未來版本開啟
        // disabledDate: (time) => { // 設置會議時間選擇器 時間範圍限制
        //   let day = (this.data.category !== null && this.data.category == '0') ? 10 : 2
        //   return time.getTime() < ( new Date().getTime()+day*24*60*60*1000 )
        // }
      },
      files: [],
      fileAcceptFileType: ['xlsx'],
      excelSample: '',
      reUpload: false
    }
  },
  mounted () {
    this.communityId = JSON.parse(localStorage.getItem('loginUserInfo')).ComId
    this.communityName = JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName
    this.getExcelSample()
    // eslint-disable-next-line eqeqeq
    if (this.$route.query.id != undefined) {
      this.getAssembly()
      this.getTopicList()
    } else {
      this.SetCKEditor()
    }
    // eslint-disable-next-line eqeqeq
    this.reUpload = this.$route.query.id != undefined
  },
  methods: {
    // 設定CKEditor
    SetCKEditor () {
      console.log('SetCKEditor')
      const vobj = this
      CKEDITOR.replace('editor', {
        height: 200,
        language: 'zh'
      })
      CKEDITOR.instances.editor.on('change', () => {
        const ckeditorData = CKEDITOR.instances.editor.getData()
        vobj.data.description = ckeditorData
      })
    },
    // 取得空白範本
    getExcelSample () {
      apiUnitOwnerAssembly.Assembly.GetImportationTemplate(
        {
          responseType: 'blob'
        }
      ).then(res => {
        console.log(res)
        this.excelSample = res.data
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    printSample () {
      const url = window.URL.createObjectURL(new Blob([this.excelSample]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', '區權範本.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    // 取得會議資料
    getAssembly () {
      const vobj = this
      apiUnitOwnerAssembly.Assembly.GetAssembly(
        {
          AssemblyId: this.$route.query.id
        }
      ).then(res => {
        if (res.status === 200) {
          this.data.title = res.data.title
          this.data.date = res.data.assemblyStartAt.slice(0, 10)
          this.data.startTime = res.data.assemblyStartAt.slice(11, 16)
          // eslint-disable-next-line eqeqeq
          this.data.place = res.data.place.name != null ? res.data.place.name : ''
          // eslint-disable-next-line eqeqeq
          this.data.placeAddress = res.data.place.address != null ? res.data.place.address : ''
          // eslint-disable-next-line eqeqeq
          this.data.issueTextNumber = res.data.issueTextNumber != null ? res.data.issueTextNumber : ''
          // eslint-disable-next-line eqeqeq
          this.data.category = res.data.category == 'Regular' ? '0' : '1'
          // eslint-disable-next-line eqeqeq
          this.data.host = res.data.host.name != null ? res.data.host.name : ''
          this.data.hostIdentity = res.data.host.role
          // eslint-disable-next-line eqeqeq
          this.data.contactPerson = res.data.contactPerson.name != null ? res.data.contactPerson.name : ''
          this.data.contactPersonIdentity = res.data.contactPerson.role
          // eslint-disable-next-line eqeqeq
          this.data.description = res.data.description != null ? res.data.description : ''
          this.data.note = res.data.note != null ? res.data.note : ''
          this.data.useTablet = res.data.threshold.isTabletUsed
          this.data.useArea = res.data.threshold.isAreaUsed
          this.data.num = res.data.threshold.isTabletUsed ? res.data.threshold.tabletThreshold.threshold * 100 : res.data.threshold.areaThreshold.threshold * 100
          this.data.endTime = res.data.assemblyDueAt ? res.data.assemblyDueAt.slice(11, 16) : ''
          vobj.SetCKEditor()
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 取得議案
    getTopicList () {
      apiUnitOwnerAssembly.Topic.GetTopicList(
        {
          AssemblyId: this.$route.query.id
        }
      ).then(res => {
        console.log(res)
        this.$refs.topicEdit.show(res.data)
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    goToStep (stepName) {
      // 因為直接異動 activeName 會先改值再呼叫到 beforeLeave 很麻煩，乾脆模擬點擊事件
      document.getElementById(`tab-${stepName}`).click()
    },
    checkStep (stepName) {
      // async function 不可用於 beforeLeave （判斷為 Element UI 限制）
      // 因此將一些 function 改為同步的
      // 若規則全數通過則無錯誤訊息
      let invalidMsg = ''
      switch (stepName) {
        case '1':
        // 檢查步驟一
          this.$refs.form.validate((valid, object) => {
            const objectKeys = Object.keys(object)
            // 如果有錯誤訊息則給予第一則
            if (objectKeys.length > 0) {
              invalidMsg = object[objectKeys[0]][0].message
            }
          })
          break
        case '2':
        // 檢查步驟二
        // 檢查議案標題
          invalidMsg = this.$refs.topicEdit.syncCheckRule()
          break
        case '3':
        // 檢查步驟三，建立會議
        // 檢查檔案
        // eslint-disable-next-line eqeqeq
          if (this.$route.query.id == undefined && this.data.unitOwnerListExcel.length === 0) {
            this.error.file = true
            invalidMsg = this.ErrorMsg.FILE_EMPTY
          }
          // 檢查步驟三，編輯會議
          // 檢查坪數
          if (this.$route.query.id) {
            invalidMsg = this.$refs.editRegisterList.syncCheckRule()
          }
          break
        default:
          break
      }
      // 如果有錯誤訊息
      if (invalidMsg) {
        // 1. 轉至錯誤高度
        this.$nextTick(() => {
          // 第一步驟
          let errorItems = document.getElementsByClassName('el-form-item__error')
          // 第二步驟
          if (errorItems.length === 0) {
            errorItems = document.getElementsByClassName('titleError')
          }
          // 第三步驟沒機會那麼高
          if (errorItems.length > 0) {
            const errorItemBoundingClientRect = errorItems[0].getBoundingClientRect()
            const errorItemAbsY = errorItemBoundingClientRect.top + window.scrollY
            const paddingTop = 350
            const errorItemAbsYwithPadding = errorItemAbsY - paddingTop
            // 不知為何 smooth 偶發會停住因此關掉
            window.scrollTo(
              {
                top: errorItemAbsYwithPadding,
                left: 0
                // behavior: 'smooth'
              })
          }
        })
        // 2. 跳提醒
        this.$message.error('請正確填選標示為“ * ”必填欄位')
      }
      return invalidMsg === ''
    },
    checkCurrentStep (nextStep) {
      return parseInt(this.activeName, 10) > parseInt(nextStep, 10) ? true : this.checkStep(this.activeName)
    },
    beforeLeave (nextStep) {
      return this.checkCurrentStep(nextStep)
    },
    nextStep () {
      // 實際上是 call click tab 的 function
      // 此 function 會 call beforeLeave 的 function，因此會驗證通過才離開此步驟
      // activeName 其實是字串，只是裡面的值先前即給 1, 2, 3
      const nextNum = this.activeName === '3' ? 1 : parseInt(this.activeName, 10) + 1
      const nextString = nextNum.toString()
      this.goToStep(nextString)
    },
    backStep () {
      const backNum = this.activeName === '1' ? 1 : parseInt(this.activeName, 10) - 1
      const backString = backNum.toString()
      this.goToStep(backString)
    },
    // 送出會議
    async submit () {
      let error = false
      // 如果不合格就導去需調整的步驟（新增會議時有可能填寫完步驟一即切換到步驟三，略過步驟二）
      for (let index = 1; index < 4; index++) {
        const indexString = index.toString()
        if (this.checkStep(indexString) === false) {
          error = true
          this.goToStep(indexString)
          return
        }
      }
      if (error === false) {
        // 整理step 1資料
        const requestData = {
          Title: this.data.title,
          IssueTextNumber: this.data.issueTextNumber,
          Category: this.data.category === '0' ? 'Regular' : 'Extraordinary', // 0 定期會議、1臨時會議
          AssemblyStartAt: this.data.date + ' ' + this.data.startTime,
          CommunityId: this.communityId,
          PlaceName: this.data.place,
          PlaceAddress: this.data.placeAddress,
          HostRole: this.data.hostIdentity,
          HostName: this.data.host,
          ContactPersonRole: this.data.contactPersonIdentity,
          ContactPersonName: this.data.contactPerson,
          Note: this.data.note,
          TabletThreshold: this.data.useTablet ? this.data.num / 100 : 0,
          AreaThreshold: this.data.useArea ? this.data.num / 100 : 0,
          Description: processCKEditorData(this.data.description),
          NotificationType: 'App'
        }
        if (this.data.endTime) { requestData.AssemblyDueAt = this.data.date + ' ' + this.data.endTime }
        this.fullScreenLoading(true)
        // eslint-disable-next-line eqeqeq
        if (this.$route.query.id != undefined) {
          this.editAssembly(requestData)
        } else {
          this.createAssembly(requestData)
        }
      }
    },
    // 建立會議
    async createAssembly (requestData) {
      // 整合議案資料
      await this.$refs.topicEdit.getTopicString().then(res => {
        requestData.TopicDtoJsonStrings = res
      })
      // 整合excel資料
      requestData.UnitOwnerListExcel = this.data.unitOwnerListExcel[0].file
      console.log(requestData)
      const formData = new FormData()
      for (const key in requestData) {
        formData.append(key, requestData[key])
      }
      apiUnitOwnerAssembly.Assembly.CreateAssembly(
        formData
      ).then(res => {
        console.log(res)
        this.fullScreenLoading(false)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.$confirm('會議已建立成功，要直接發佈會議嗎？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            this.publishAssembly(res.data)
          }).catch(() => {
            this.$message({
              message: '會議建立成功！',
              type: 'success'
            })
            this.$router.push({ name: 'UnitOwnerAssembly' })
          })
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response.status == 400) {
          this.fullScreenLoading(false)
          // eslint-disable-next-line eqeqeq
          if (err.response.data.description == '區權人名單含有不正確的戶別資料(可能是不同社區資料)') {
            this.$alert('上傳失敗，請檢查Excel檔案【戶別坪數】都已正確填寫', '錯誤', {
              confirmButtonText: '確定',
              type: 'error',
              callback: action => {}
            })
          } else {
            this.$alert(err.response.data.description, '錯誤', {
              confirmButtonText: '確定',
              type: 'error',
              callback: action => {}
            })
          }
        }
      })
    },
    // 發布會議
    publishAssembly (assemblyId) {
      apiUnitOwnerAssembly.Assembly.PublishAssembly(
        {
          assemblyId
        }
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.$message({
            message: '會議建立並發佈成功！',
            type: 'success'
          })
          this.$router.push({ name: 'UnitOwnerAssembly' })
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 編輯會議
    async editAssembly (requestData) {
      // Step1 - Step2-1
      // 更新會議基本資料
      // 更新報到統計規則
      let updateBasicDataAndRules
      try {
        requestData.AssemblyId = this.$route.query.id
        const formData = new FormData()
        for (const key in requestData) {
          formData.append(key, requestData[key])
        }
        updateBasicDataAndRules = await apiUnitOwnerAssembly.Assembly.EditAssembly(
          formData
        )
      } catch (error) {
        this.$message({
          message: '會議基本資料、報到統計規則更新失敗！',
          type: 'warning'
        })
      }
      // 檢查與詢問佩穎後認為不會再進入，因此刪除 ↑
      // Step2-2
      // 更新議案資料
      let updateTopicList
      try {
        updateTopicList = await this.$refs.topicEdit.updateTopicList()
      } catch (error) {
        this.$message({
          message: '議案資料更新失敗！',
          type: 'warning'
        })
      }
      // Step3
      // 更新區權人名冊資料
      let updateRegisterList
      try {
        updateRegisterList = await this.$refs.editRegisterList.save()
      } catch (error) {
        this.$message({
          message: '區權人名冊更新失敗！',
          type: 'warning'
        })
      }
      // 失敗則 undefined
      if (updateBasicDataAndRules && updateTopicList && updateRegisterList) {
        this.$message({
          message: '會議更新成功！',
          type: 'success'
        })
        this.$router.push({ name: 'UnitOwnerAssembly' })
      } else {
        // 若失敗將會跳出哪個步驟更新失敗與會議更新失敗兩種提示
        this.$message({
          message: '會議更新失敗！',
          type: 'warning'
        })
      }
      // 不論成功或失敗都要將 loading 畫面關閉
      this.fullScreenLoading(false)
    },
    // 匯入區權戶資料
    filesChange (val) {
      this.data.unitOwnerListExcel = val
      this.error.file = false
    },
    checkThreshold () {
      // 本來會報 error，改為統一跟著下方議案一樣判斷為空值就先塞預設值
      if (!this.data.num) {
        this.$nextTick(() => {
          this.data.num = 50.00
          console.log('checkThreshold', this.data.num)
        })
      }
    },
    // 報到統計規則欄位，不可都不勾選
    handleThresholdCheckboxChange () {
      // 此 function 改為只驗證 checkbox 的部分
      if (this.data.useTablet === false && this.data.useArea === false) { this.data.useTablet = true }
    },
    categoryChange (type) {
      // if(this.data.date){ // 若先填寫會議日期，走校驗流程
      //   let day = (type == '0') ? 10 : 2
      //   console.log(day)
      //   if(new Date(this.data.date).getTime() < (new Date().getTime()+day*24*60*60*1000)){
      //     console.log('不通過')
      //     this.error.date = '定期會議不可在10天內召開'
      //   }else{
      //     console.log('通過')
      //     this.error.date = ''
      //   }
      // }else{
      //   this.$refs.date.focus()
      // }
    },
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    },
    cancel () {
      this.$confirm('會議尚未儲存，確定離開？', '標題', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({ name: 'UnitOwnerAssembly' })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="sass" scoped>
#AssemblyEdit_main
  +mainLayer
  max-width: 1140px
  margin: 0 auto
  .required
    position: relative
    color: $dangerColor
    +redStar
  .el-tabs
    +TabsToSteps
    #pane-1
      margin-top: 10px
      ::v-deep .el-form
        +basicForm
        max-width: 70%
        margin: 0 auto
        text-align: left
        .el-form-item
          &.time
            width: 250px
            display: inline-block
            margin-bottom: 0
            &:nth-child(1)
              width: 225px
          &.is-required
            .el-form-item__label
              position: relative
              +redStar
        .el-form-item__label
          line-height: 40px
          margin-right: 0px
        .el-form-item__content
          .ex
            color: $subFontColor
            font-size: 13px
    #pane-2
      margin-top: 10px
      width: 100%
      .content
        width: 70%
        margin: 0 auto 20px
        display: flex
      .left
        width: 130px
        text-align: left
        position: relative
        line-height: 42px
        +redStar
      .right
        color: $subFontColor
        .el-checkbox
          line-height: 42px
        .threshold
          display: inline-block
          position: relative
          ::v-deep .el-input-number.inputnum
            width: 90px
            margin-left: 20px
            &.error
              .el-input__inner
                border-color: $dangerColor
            .el-input-number__decrease,.el-input-number__increase
              display: none
            .el-input
              .el-input__inner
                font-weight: bold
                font-size: 18px
                letter-spacing: 2px
                padding-right: 0
                padding-left: 0
                color: $subFontColor
          .errorNum
            position: absolute
            top: 45px
            left: 20px
            text-align: left
            color: $dangerColor
            font-size: 12px
        div.num
          display: inline-block
          font-size: 18px
          line-height: 40px
          margin-left: 5px
    #pane-3
      ::v-deep .file_frame
        &.redFile
          .file
            border: 1px solid $dangerColor
            color: $dangerColor
      ::v-deep .file-tip
        display: none
      ::v-deep .file
        margin: 10px auto
      .fileError
        color: $dangerColor
        text-align: center
        margin: 0 auto 10px
      .file-content
        width: 480px
        margin: 0 auto
        cursor: pointer
        background-color: $bgDark3
        padding: 9px 16px 7px
        .green
          color: $mainColor
    .bottomControl
      margin-top: 20px
</style>
